import { render, staticRenderFns } from "./ReviewProducts.vue?vue&type=template&id=5dc1b34e&scoped=true"
import script from "./ReviewProducts.vue?vue&type=script&lang=ts"
export * from "./ReviewProducts.vue?vue&type=script&lang=ts"
import style0 from "./ReviewProducts.vue?vue&type=style&index=0&id=5dc1b34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1b34e",
  null
  
)

export default component.exports